import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "application-status__title" }
const _hoisted_3 = { class: "application-status__content" }
const _hoisted_4 = ["innerHTML"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationStatus',
  props: {
        title: {
            type: String,
            required: true,
        },
        imageUrl: {
            type: String,
            required: true,
        },
        ctaLabel: {
            type: String,
            required: false,
        },
        faqLink: {
            type: String,
            required: false,
        },
    },
  emits: ["waiting-room-cta:clicked"],
  setup(__props, { emit: __emit }) {

    

    const emits = __emit;

    function handleCtaClick() {
        emits('waiting-room-cta:clicked');
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyButton = _resolveComponent("VJoyButton")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VJoyWrapper, {
      class: "application-status",
      "row-gap": "6",
      direction: "column",
      "no-margin": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: __props.imageUrl,
          alt: ""
        }, null, 8, _hoisted_1),
        _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "content")
        ]),
        (__props.ctaLabel)
          ? (_openBlock(), _createBlock(_component_VJoyButton, {
              key: 0,
              variant: "main",
              "data-testid": "profile-creation-waiting-room-cta",
              onClick: handleCtaClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.ctaLabel), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    (__props.faqLink)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          innerHTML: __props.faqLink
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})